// Señal del navegador para la cámara del asistente KYC.
//
// Módulo PURO (sin imports), testeado con Node en
// spec/javascript/kyc_camera_signal_spec.mjs. KycUpload.startPreview
// (app/views/shared/_kyc_upload_helpers.html.erb) emite el evento del DOM la
// primera vez que una página tiene que mostrar el toque para activar la
// cámara, el aviso de cámara sin imagen o se queda sin cámara después de
// reabrirla. sentry.js lo reenvía como warning.
//
// Por qué hace falta: desde #1538 el cuadro negro ya no se sube (la página no
// deja disparar sin imagen), así que el servidor deja de verlo. Sin esta señal,
// quien abandona con la cámara en negro (navegador interno de Instagram o
// Facebook, acceso a la cámara apagado) sería invisible.
export const KYC_CAMERA_EVENT = 'arcadi:kyc-camara';

const EVENTOS = new Set(['toque', 'sin_imagen', 'camara_perdida']);
const PASOS = new Set(['selfie', 'frente', 'reverso']);

// detail: { evento, paso } tal como lo arma la página. Devuelve null si el
// evento no es uno de los conocidos (nada que reportar). Sin datos personales:
// solo el evento y el paso; la URL y el navegador los agrega el SDK y los
// limpia el scrub de sentry.js. Agrupado por evento: una sola issue por tipo
// de falla, con el paso como etiqueta.
export function kycCameraSentryMessage(detail) {
  const evento = detail && detail.evento;
  if (!EVENTOS.has(evento)) return null;

  const paso = PASOS.has(detail.paso) ? detail.paso : 'desconocido';
  return {
    message: `KYC: cámara del navegador (${evento})`,
    context: {
      level: 'warning',
      tags: { feature: 'kyc_camara', evento, paso },
      fingerprint: ['kyc_camara_navegador', evento],
    },
  };
}
